module.exports = __webpack_public_path__ + "resources/img/img_intermax_4.7b22aaa751df98e42a84253a2b870c1c.png";